// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"StartBgVideo_bgVideoWrapper__GZ6DR","unvisible":"StartBgVideo_unvisible__DZ5P2"};